"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLazyGetNextInvoiceNumberQuery = exports.usePushInvoiceBatchMutation = exports.useFetchInvoicesQuery = exports.useCommitInvoiceBatchMutation = exports.usePreviewInvoiceBatchMutation = exports.invoiceApi = void 0;
// api/invoiceApi.ts — IF-004.3: invoice-number preview/commit + billing-log reads.
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
exports.invoiceApi = (0, react_1.createApi)({
    reducerPath: "invoiceApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.LETS_CUE_API),
    tagTypes: ["invoices"],
    endpoints: function (builder) { return ({
        previewInvoiceBatch: builder.mutation({
            query: function (body) { return ({ url: "/v1/invoice/preview", method: "POST", body: body }); },
        }),
        commitInvoiceBatch: builder.mutation({
            query: function (body) { return ({ url: "/v1/invoice/commit", method: "POST", body: body }); },
            invalidatesTags: ["invoices"],
        }),
        fetchInvoices: builder.query({
            query: function (params) { return ({ url: "/v1/invoice/all", method: "GET", params: params }); },
            providesTags: ["invoices"],
        }),
        /*
         * XInt-3.1: send every approved invoice for this batch to Xero.
         *
         * Scoped to the batch rather than a list of ids on purpose — the user must not be able to send only
         * part of it here; that choice was made when they approved the charges. Safe to call twice: an
         * invoice already in Xero is skipped, so a re-run sends only what failed.
         */
        pushInvoiceBatch: builder.mutation({
            query: function (body) { return ({ url: "/v1/invoice/push-batch", method: "POST", body: body }); },
            invalidatesTags: ["invoices"],
        }),
        // Next invoice number to start a batch at (last-used + 1) — used to pre-fill the "First invoice no." field.
        getNextInvoiceNumber: builder.query({
            query: function (params) { return ({ url: "/v1/invoice/next-number", method: "GET", params: params }); },
            providesTags: ["invoices"],
        }),
    }); },
});
exports.usePreviewInvoiceBatchMutation = exports.invoiceApi.usePreviewInvoiceBatchMutation, exports.useCommitInvoiceBatchMutation = exports.invoiceApi.useCommitInvoiceBatchMutation, exports.useFetchInvoicesQuery = exports.invoiceApi.useFetchInvoicesQuery, exports.usePushInvoiceBatchMutation = exports.invoiceApi.usePushInvoiceBatchMutation, exports.useLazyGetNextInvoiceNumberQuery = exports.invoiceApi.useLazyGetNextInvoiceNumberQuery;
